import { ReactNode, useState } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import Avatar, { AvatarProps } from '@mui/material/Avatar';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import InputAdornment from '@mui/material/InputAdornment';
import OutlinedInput from '@mui/material/OutlinedInput';
import Popper from '@mui/material/Popper';
import Box from '@mui/material/Box';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';





// third party
import PopupState, { bindPopper, bindToggle } from 'material-ui-popup-state';

// project imports
import Transitions from 'ui-component/extended/Transitions';

// assets
import { IconAdjustmentsHorizontal, IconSearch, IconX } from '@tabler/icons-react';
import { MessProject } from '@api-client/models/MessProject';



interface HeaderAvatarProps extends AvatarProps {
  children: ReactNode;
}

function HeaderAvatar({ children, ref, ...others }: HeaderAvatarProps) {
  const theme = useTheme();

  return (
    <Avatar
      ref={ref}
      variant="rounded"
      sx={{
        ...theme.typography.commonAvatar,
        ...theme.typography.mediumAvatar,
        color: theme.vars.palette.secondary.dark,
        background: theme.vars.palette.secondary.light,
        '&:hover': {
          color: theme.vars.palette.secondary.light,
          background: theme.vars.palette.secondary.dark
        },

        ...theme.applyStyles('dark', {
          color: theme.vars.palette.secondary.main,
          background: theme.vars.palette.dark.main,
          '&:hover': {
            color: theme.vars.palette.secondary.light,
            background: theme.vars.palette.secondary.main
          }
        })
      }}
      {...others}
    >
      {children}
    </Avatar>
  );
}

interface Props {
  value: string;
  setValue: (value: string) => void;
  popupState: any;
}

// ==============================|| SEARCH INPUT - MOBILE||============================== //

function MobileSearch({ value, setValue, popupState }: Props) {
  const theme = useTheme();

  return (
    <OutlinedInput
      id="input-search-header"
      value={value}
      onChange={(e) => setValue(e.target.value)}
      placeholder="Search X"
      startAdornment={
        <InputAdornment position="start">
          <IconSearch stroke={1.5} size="16px" />
        </InputAdornment>
      }
      endAdornment={
        <InputAdornment position="end">
          <HeaderAvatar>
            <IconAdjustmentsHorizontal stroke={1.5} size="20px" />
          </HeaderAvatar>
          <Box sx={{ ml: 2 }}>
            <Avatar
              variant="rounded"
              sx={{
                ...theme.typography.commonAvatar,
                ...theme.typography.mediumAvatar,
                bgcolor: 'orange.light',
                color: 'orange.dark',
                '&:hover': { bgcolor: 'orange.dark', color: 'orange.light' },

                ...theme.applyStyles('dark', { bgcolor: theme.vars.palette.dark.main })
              }}
              {...bindToggle(popupState)}
            >
              <IconX stroke={1.5} size="20px" />
            </Avatar>
          </Box>
        </InputAdornment>
      }
      aria-describedby="search-helper-text"
      slotProps={{ input: { 'aria-label': 'weight', sx: { bgcolor: 'transparent', pl: 0.5 } } }}
      sx={{ width: '100%', ml: 0.5, px: 2, bgcolor: 'background.paper' }}
    />
  );
}

// ============================ MESSPROJECT SEARCH ============//





// ==============================|| SEARCH INPUT ||============================== //
import * as React from 'react';
// import { useState } from 'react';
import { useSession } from '../../../../SessionContext';
import {useIntl} from 'react-intl';
import { MessProjectsService } from '@api-client/services/MessProjectsService';
import { ProjectsService } from '@api-client/services/ProjectsService';
import IssueDialogComponent from '../../../../components/IssueDialogComponent';
import Typography from 'views/utilities/Typography';



//import DocumentComponent from '../../../../components/DocumentComponent';
export default function SearchSection() {
  const commit = import.meta.env.GIT_COMMIT;
  const [value, setValue] = useState('');
  const [messProjects, setMessProjects] = React.useState<MessProject[]>([]);
  const { session, setSession } = useSession();
  const intl = useIntl();
  React.useEffect(() => {
    const loadMessProjects = async () => {
      try {
        console.log('Loading mess projects for session:', session?.current_project  );
        let  list_of_messprojects: MessProject[] = [];
        if (session?.current_project) {
          let pid = session.current_project?.id || '';
          console.log('Loading mess projects for project:',session.current_project);
          list_of_messprojects = await ProjectsService.getMessprojectsByProject(pid);          
        }
        else {
          list_of_messprojects = await MessProjectsService.listMessprojects(0, 100);
          
        }
        setMessProjects(list_of_messprojects as MessProject[]);
      } catch (error) {
        console.error('Failed to load mess projects:', error);
      }
    };
    loadMessProjects();
  }, [session?.current_project]);

  const MessProjectSelection = () => {
    return (
      <Autocomplete
        disablePortal
        // disabled
        options={messProjects}
        value={session?.current_messproject || null}
        onChange={async (event, newValue) => {
          if (session && newValue) {
            try {
              const selected_messproject = await MessProjectsService.getMessproject(newValue.id || '');
              setSession({
                ...session,
                current_messproject: selected_messproject //response.data
              });
            } catch (error) {
              console.error('Failed to fetch messproject:', error);

            }
          }
        }}
        
        getOptionLabel={(option) => `${option.name}`}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        
        sx={{ width: { md: 250, lg: 434 }, ml: 0, px: 2 }}
        renderInput={(params) => <TextField {...params} label={intl.formatMessage({ id: 'messproject', defaultMessage: 'Structure' })} />}
      />

    );
  };


  return (
    <>
      <Box sx={{ display: { xs: 'block', md: 'none' } }}>
        <PopupState variant="popper" popupId="demo-popup-popper">
          {(popupState) => (
            <>
              <Box sx={{ ml: 2 }}>
                <HeaderAvatar {...bindToggle(popupState)}>
                  <IconSearch stroke={1.5} size="19.2px" />
                </HeaderAvatar>
              </Box>
              <Popper
                {...bindPopper(popupState)}
                transition
                sx={{ zIndex: 1100, width: '99%', top: '-55px !important', px: { xs: 1.25, sm: 1.5 } }}
              >
                {({ TransitionProps }) => (
                  <>
                    <Transitions type="zoom" {...TransitionProps} sx={{ transformOrigin: 'center left' }}>
                      <Card sx={{ bgcolor: 'background.default', border: 0, boxShadow: 'none' }}>
                        <Box sx={{ p: 2 }}>
                          <Grid container sx={{ alignItems: 'center', justifyContent: 'space-between' }}>
                            <Grid size="grow">
                              <MobileSearch value={value} setValue={setValue} popupState={popupState} />
                            </Grid>
                          </Grid>
                        </Box>
                      </Card>
                    </Transitions>
                  </>
                )}
              </Popper>
            </>
          )}
        </PopupState>
      </Box>
      <Box sx={{ display: { xs: 'none', md: 'block' } }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <MessProjectSelection />
        </Box>
        {/* <OutlinedInput
          id="input-search-header"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder="Xearch"
          startAdornment={
            <InputAdornment position="start">
              <IconSearch stroke={1.5} size="16px" />
            </InputAdornment>
          }
          endAdornment={
            <InputAdornment position="end">
              <HeaderAvatar>
                <IconAdjustmentsHorizontal stroke={1.5} size="20px" />
              </HeaderAvatar>
            </InputAdornment>
          }
          aria-describedby="search-helper-text"
          slotProps={{ input: { 'aria-label': 'weight', sx: { bgcolor: 'transparent', pl: 0.5 } } }}
          sx={{ width: { md: 250, lg: 434 }, ml: 2, px: 2 }}
        /> */}
        
          
        
      </Box>
    </>
  );
}
